import { render, staticRenderFns } from "./imageInput.vue?vue&type=template&id=2565d418&scoped=true"
import script from "./imageInput.vue?vue&type=script&lang=js"
export * from "./imageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565d418",
  null
  
)

export default component.exports